import * as Sentry from '@sentry/react';

const SENTRY_DSN = 'https://e9f72b9eab30776fa7605e0d8342e4c8@o1388406.ingest.us.sentry.io/4511097340100608';

let isInitialized = false;

export function initSentry(): void {
  if (import.meta.env.DEV || isInitialized) return;

  Sentry.init({
    dsn: SENTRY_DSN,
  });

  isInitialized = true;
}

export { Sentry };
